import { render, staticRenderFns } from "./leadManagerCard.vue?vue&type=template&id=19d4ba6a"
import script from "./leadManagerCard.vue?vue&type=script&lang=js"
export * from "./leadManagerCard.vue?vue&type=script&lang=js"
import style0 from "./leadManagerCard.vue?vue&type=style&index=0&id=19d4ba6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports